/**
 * @fileoverview Reset-password page.
 * @description The /reset-password route the Forgot Password email links to
 * (`<APP_URL>/reset-password?token=...`, built by the identity backend). Composes the auth page
 * shell with ResetPasswordCard, which verifies the token and shows the new-password form.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { ResetPasswordCard } from '@/features/auth'
import AuthLayout from '@/shared/components/layouts/AuthLayout'

/**
 * @component
 */
function ResetPasswordPage() {
  return (
    <AuthLayout>
      <ResetPasswordCard />
    </AuthLayout>
  )
}

export default ResetPasswordPage
